export default __webpack_public_path__ + "static/media/banner-image.b68bdead.png";